module.exports = __webpack_public_path__ + "img/upload_license.0f673f9d.svg";